import { AuthService } from '@app/modules/angular-6-social-login-master';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { WebSiteUsersService } from './../../../services/webSiteUsers/webSiteUsers.service';
import { Subscription } from 'rxjs';
import { Component, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { localStorageService } from '@app/services/localStorage/localStorage.service';
@Component({
    selector: 'top-navig',
    templateUrl: 'top-navig.component.html',
    styleUrls: ['top-navig.component.scss'],
    providers:[AuthService]
})

export class TopNavigComponent {
    isCollapsed = true;
    config = { ignoreBackdropClick: true };
    log: boolean = false;
    customerName: string = '';
    order: any = { elementsNbr: 0 };
    @ViewChild('navbar') navbar: ElementRef
    subscriptions: Subscription[] = [];
    bsModalRef: BsModalRef;
    chosenOrderType: number;
    orderType: number;
    constructor(
        public router: Router,
        private webSiteUsersService: WebSiteUsersService,
        private localStorage: localStorageService,
        private OAuth: AuthService
    ) {
        let sub = this.webSiteUsersService.listener.subscribe(
            log => {
                this.log = log
            }
        )
        this.subscriptions.push(sub);
    }

    activeRoute(routename: string): boolean {
        return this.router.url.indexOf(routename) == 0 && this.router.url.indexOf(routename + '/') == -1;
    }

    logout() {
        this.OAuth.signOut().then()
        this.localStorage.clear();
        this.webSiteUsersService.listener.next(false);
        this.router.navigate(['/']);
    }

    // @HostListener('window:scroll', ['$event']) onScrollEvent($event) {
    //     if(window.pageYOffset>0){
    //         this.navbar.nativeElement.classList.add('navbar-scroll')
    //     }else{
    //         this.navbar.nativeElement.classList.remove('navbar-scroll')
    //     }
    // }
    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

    ngOnDestroy() {
        this.unsubscribe();
    }
}
